import React, { useEffect } from "react";
import "./EasyPayPlanModal.css";
import Loader from "../../../../../shared/loader/Loader";
import { useSelector } from "react-redux";
import { Modal } from "reactstrap";
import DashboardPopup from "../../../../../BrotherPlus/DashboardPopup/DashboardPopup";
import { routePath } from "../../../../../../constants/Routes";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";


const EasyPayPlanModal = (props) =>{
    const { isOpen, onClose, onSkipService } = props;
    const history = useHistory();
    const BrotherPlusRegistrationResult = useSelector(state => state.BROTHERPLUS.RegisterService);

    useEffect(() => {
        if(BrotherPlusRegistrationResult.success){
            onClose();

            // reload dashboard tab to load both EcoPro and BrotherPlus widgets
            history.push(routePath.DASHBOARD)
        }
        // eslint-disable-next-line
    }, [BrotherPlusRegistrationResult]);
    
    const handleOverlayClick = (e) => {
        onSkipService(true);
        // if (e.target.id === "overlay") {
              onClose();
        //}
    };
  
    if (!isOpen) return null;
    return (
        <Modal isOpen={isOpen}  toggle={()=>handleOverlayClick()} backdrop={true} className={`cs-agent-modal-overview brother-plus-dashboard-initial-popup-modal`}>
            <div className="modal-content-wrapper" onClick={(e) => e.stopPropagation()}>
                { 
                    (BrotherPlusRegistrationResult.loading)
                    ? 
                    <div className="easy-pay-plan-modal-wrapper overlay">
                    <Loader slowResponse = {true} setOverlay={true} isModalComp={true}/>
                    </div>
                    : (BrotherPlusRegistrationResult.success || BrotherPlusRegistrationResult.error) 
                        ? null
                        : 
                        <DashboardPopup source="ECOPRO_DASHBOARD" onSkipService = {onSkipService} showSkip={true} onClose = {onClose} showGetStartedBtn={true}/>
                }
            </div>
        </Modal>
    )
}
export default EasyPayPlanModal;